module.exports = __webpack_public_path__ + "img/profile-img.d127e2b0.jpg";